module.exports = __webpack_public_path__ + "img/Adobe.f1c6b86d.png";